import { render, staticRenderFns } from "./MenuListComponentOld.vue?vue&type=template&id=26c7e2fe&scoped=true"
import script from "./MenuListComponentOld.vue?vue&type=script&lang=js"
export * from "./MenuListComponentOld.vue?vue&type=script&lang=js"
import style0 from "./MenuListComponentOld.vue?vue&type=style&index=0&id=26c7e2fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c7e2fe",
  null
  
)

export default component.exports